import { create } from 'zustand';
import type { Tenant, User } from '@/types';

interface AuthState {
    user: User | null;
    tenant: Tenant | null;
    isLoading: boolean;
    impersonating: boolean;
    impersonatorName: string | null;
    setSession: (user: User | null, tenant: Tenant | null, impersonating?: boolean, impersonatorName?: string | null) => void;
    setLoading: (isLoading: boolean) => void;
    /** Patches just the user record (e.g. after a profile edit) without the full-page "Loading…" flash setLoading(true) causes — that's for session bootstrap/login/tenant-switch, not a same-page field update. */
    updateUser: (user: User) => void;
    clear: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
    user: null,
    tenant: null,
    isLoading: true,
    impersonating: false,
    impersonatorName: null,
    setSession: (user, tenant, impersonating = false, impersonatorName = null) =>
        set({ user, tenant, isLoading: false, impersonating, impersonatorName }),
    setLoading: (isLoading) => set({ isLoading }),
    updateUser: (user) => set({ user }),
    clear: () => set({ user: null, tenant: null, isLoading: false, impersonating: false, impersonatorName: null }),
}));
